import { Component, computed, inject, Signal } from '@angular/core';
import {
  IProgressBarStep,
  TicketConfigurationProgressTrackerComponent,
} from '../../../components/feedback/ticket-configuration-progress-tracker/ticket-configuration-progress-tracker.component';
import { RouterOutlet } from '@angular/router';
import { ERoute } from '../../../constants/routes.enum';
import { ShoppingCartService } from '../../../services/shopping-cart/shopping-cart.service';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { EEntityType, ERelationType } from '@web/dtos';

@Component({
  selector: 'aw-on-demand-ticket-configuration-page',
  templateUrl: './on-demand-ticket-configuration-page.component.html',
  imports: [TicketConfigurationProgressTrackerComponent, RouterOutlet],
})
export class OnDemandTicketConfigurationPage {
  private readonly shoppingCart: ShoppingCartService =
    inject(ShoppingCartService);
  private readonly textStore: WebTextStore = inject(WebTextStore);

  private readonly textFilterPipe: FilterTextsPipe = new FilterTextsPipe();
  private readonly languagePipe: LanguagePipe = new LanguagePipe();

  protected readonly ERoute: typeof ERoute = ERoute;
  protected readonly ERelationType: typeof ERelationType = ERelationType;

  protected readonly progressBar: Signal<IProgressBarStep[]> = computed(() => {
    return [
      {
        label: this.languagePipe.transform(
          this.textFilterPipe.transform(
            this.textStore.texts(),
            ERelationType.additionalData,
            EEntityType.onDemandTicketConfiguration
          )
        ),
        stepIndex: 0,
        url: `${ERoute.onDemandTicketConfiguration}/${ERoute.options}/${this.shoppingCart.directTicketConfiguration()?.name}`,
      },
      {
        label: this.languagePipe.transform(
          this.textFilterPipe.transform(
            this.textStore.texts(),
            ERelationType.reservation,
            EEntityType.onDemandTicketConfiguration
          )
        ),
        stepIndex: 1,
        url: `${ERoute.onDemandTicketConfiguration}/${ERoute.reservation}`,
      },
      {
        label: this.languagePipe.transform(
          this.textFilterPipe.transform(
            this.textStore.texts(),
            ERelationType.passengerData,
            EEntityType.onDemandTicketConfiguration
          )
        ),
        stepIndex: 2,
        url: `${ERoute.onDemandTicketConfiguration}/${ERoute.passengerData}`,
      },
      {
        label: this.languagePipe.transform(
          this.textFilterPipe.transform(
            this.textStore.texts(),
            ERelationType.payment,
            EEntityType.onDemandTicketConfiguration
          )
        ),
        stepIndex: 3,
        url: `${ERoute.onDemandTicketConfiguration}/${ERoute.payment}`,
      },
      {
        label: this.languagePipe.transform(
          this.textFilterPipe.transform(
            this.textStore.texts(),
            ERelationType.checkout,
            EEntityType.onDemandTicketConfiguration
          )
        ),
        stepIndex: 4,
        url: `${ERoute.onDemandTicketConfiguration}/${ERoute.checkout}`,
      },
    ];
  });
}
